import React, { useState, useRef, useMemo } from 'react';
import {StyledLeadContainer, CreateLeadFooter, StyledSubHeader, StyledFlexEnd, StyledGridContainer} from '../../Components/Styled/index';
import { Box, Button, Stack, Tooltip, Typography, } from '@mui/material';
import LeadAccordion from '../../Components/LeadAccordion';
import { privateRoutesPath } from '../../Routes';
import {useSnackbar} from 'notistack';
import { createRequestData, getEntityColumns,validateFields } from '../../Utility/apiHelper';
import LeadProduct from '../../Components/LeadProduct';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { requestShowLoader, requestHideLoader } from '../../Store/Global/action';
import BiztantuLoader from '../../Components/Loader';
import { createFilterOptions } from '@mui/material';
import { ACTIVE_STATUS,LEAD_DESIRABILITY,LEAD_SOURCE,  handleValidateCodevalue, STATIC_ENTITY_CONFIG, phoneCountryCodes, ADDITIONAL_ATTRIBUTE_FIELDS, CUSTOMIZABLE_FIELDS_LEAD, searchEntity} from '../../Utility/constant';
import { formatAdditionalAttributesForPayload} from '../../Utility/payloadFormatter';
import SelectBoxWithLabel from '../../Components/SelectBoxWithLable';
import { EntityNote } from '../../Components/EntityNote';
import AddressFields from '../../Components/AddressFields';
import TextFiledWithLabel from '../../Components/TextFieldWithLabel';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import CommonComm from '../../Components/CommonComm';
import AutoCompleteComponent from '../../Components/AutoCompleteComponenet';
import CommonPoc from '../../Components/CommonPoc';
import { requestGetAllCustomers } from '../../Store/Customer/action';
import LeadDialog from '../../Components/LeadDialog';
import { useIsMobile } from '../../Utility/hooks/useIsMobile';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CheckIcon from '@mui/icons-material/Check';
import CustomizableFields from '../../Components/CustomizableFields';
import { requestGetAllActiveProducts } from '../../Store/Product/action';
import useNavigation from '../../Utility/hooks/useNavigation';
import './Lead.css';

const CreateLead = (props) => {
    const specificRolePermission = useSelector(state => state?.owner?.rolebasedData);
    const [selectedproduct, setSelectedproduct] = useState(null);
    const [selectedproductData, setSelectedProductData] = useState(null);
    const [isRequired, setIsRequired] = useState({});
    const [requiredFollowUp, setRequiredFollowup] = useState({
        followupNote: false,
        followupDate: false,
        followupStatus: false
    })
    const internationalise = useSelector(state => state?.internationalise?.currentHashMapData);
    const [tableData, setTableData] = useState([]);
    const [pricerange, setpricerange] = React.useState([0, 100000000]);
    var filterdOptionlist = [];
    const [inputprice, setInputprice] = useState({
        pricefromInput: 0,
        pricetoInput: 100000000
    })
    const [selectedaddedproduct, setselectedaddedproduct] = useState([]);
    const [productQuantity, setproductQuantity] = useState(null);
    const currentUser = useSelector(state => state?.owner?.currentuser);
    const [currentLeadDetail, setCurrentLeadDetail] = useState({
        ...phoneCountryCodes,
         ownerId: currentUser?.userId
    })
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const isLoadingProgress = useSelector(state => state?.global.isLoading);
    const inputRef = useRef(null);
    const followupRef = useRef(null);
    const leadData = props.location.state;
    const dispatch = useDispatch();
    const ownerlist = useSelector(state => state?.owner?.ownerlist);
    const location = useLocation();
    const leadSourceData = useSelector(state => state?.lookup?.lookupData)?.find((item) => item?.name == LEAD_SOURCE)?.codes?.filter(item => item?.status == ACTIVE_STATUS)?.sort((a,b) => a?.sequence - b?.sequence);
    const leadDesrirabilityData = useSelector(state => state?.lookup?.lookupData)?.find((item) => item?.name == LEAD_DESIRABILITY)?.codes?.filter(item => item?.status == ACTIVE_STATUS)?.sort((a,b) => a?.sequence - b?.sequence);
    const myTeam = useSelector(state => state?.owner?.Team);
    const allEntityData = useSelector((state) => state?.customization?.allEntityData || []);
    const leadTextfieldsData = useMemo(() => {
            const data = getEntityColumns(allEntityData, "LEAD");
            const {id,customerId,status ,...rest} = Object.keys(data).length > 0 ?  data : STATIC_ENTITY_CONFIG?.LEAD;
    
            return rest
        }, [allEntityData]);
        
    const { navigateTo, goBackTo } = useNavigation();
    const goBack = () =>goBackTo(privateRoutesPath.LEADS,searchEntity?.lead);

    const isMobile = useIsMobile();

 useEffect(() => {
  if (currentUser?.userId) {
    const filteredOwner = ((specificRolePermission?.isAllLeadManage ? ownerlist 
        : specificRolePermission?.isLeadTeamManage ? myTeam 
        : [{
        firstName: `${currentUser?.firstname}`,
        lastName : `${currentUser?.lastname}`,
        id: currentUser?.userId,
      }]) || [])?.find(item=> currentUser?.userId === item?.id)
    setCurrentLeadDetail((detail) => ({
      ...detail,
      selectedOwner : filteredOwner,
      ownerId : filteredOwner?.id
    }));
  }
}, [currentUser,ownerlist,myTeam]);

    useEffect(() => {
        const leadCopyData = leadData?.currentLeadDetail;
        if(leadCopyData) {
            setCurrentLeadDetail({
                ...leadCopyData,
                note : "",
                ownerId : currentUser?.userId,
                selectedOwner : {
                    firstName: `${currentUser?.firstname}`,
                    lastName : `${currentUser?.lastname}`,
                    id: currentUser?.userId,
                },
                income : leadCopyData?.incomeGroup
            });
            }
    },[leadData])

    const activeProducts = useSelector(state => state?.product?.activeProducts);

    useEffect(() => {
        const selectedProductIds = leadData?.selectedProductIds;
        if (selectedProductIds && selectedProductIds.length > 0) {
            dispatch(requestShowLoader());
            dispatch(requestGetAllActiveProducts({
                params: {
                    status: "PRODUCT_STATUS_ACTIVE"
                }
            }));
        }
    }, [leadData, dispatch]);

    useEffect(() => {
        const selectedProductIds = leadData?.selectedProductIds;
        if (selectedProductIds && selectedProductIds.length > 0 && activeProducts && activeProducts.length > 0) {
            const preSelectedProducts = activeProducts
                .filter(p => selectedProductIds.includes(p.id))
                .map((item, index) => {
                    const price = parseFloat(item?.price || 0);
                    const quantity = 1;
                    const total = price * quantity;
                    return {
                        ...item,
                        quantity: 1,
                        unitOfMeasurement: item?.unit,
                        sellingPrice: item?.price,
                        cGst: item?.cgstRate,
                        sGst: item?.sgstRate,
                        surchargeRate: item?.surChangeRate,
                        grossprice: total,
                        id: item?.id,
                        productId: item?.id,
                    };
                });
            setTableData(preSelectedProducts);
            dispatch(requestHideLoader());
        }
    }, [activeProducts, leadData, dispatch]);

    useEffect(() => {
        let priceRange = [parseInt(inputprice?.pricefromInput), parseInt(inputprice?.pricetoInput)]
        setpricerange(priceRange);
      }, [inputprice])

    const handleSelectMultiproduct = (event, productData, reason) => {
        // setselectedaddedproduct(productData);
        if (productData.find(option => option.value === "select-all")) {
            setselectedaddedproduct([...selectedaddedproduct,...filterdOptionlist]);
        } else {
            setselectedaddedproduct(productData);
        }
    }

    const handleClearAfterAdded = () => {
        setselectedaddedproduct([]);
         
    }

    const handleChangeLeadData = (event) => {
        const {name , value} = event.target
        setCurrentLeadDetail({
            ...currentLeadDetail,
            [name] : value
        })
    }

    const handleSaveLaed = async () => {

      const {errors,hasError} = validateFields(leadTextfieldsData, currentLeadDetail);
              if (hasError) {
              setIsRequired(errors);
              inputRef?.current?.focus();
              enqueueSnackbar(
                  handleValidateCodevalue(internationalise, "COMMON_MSG_MANDATORY_FIELDS"),
                  { variant: "error" }
              );
              return;
        } else {
            setIsRequired({})
            if(currentLeadDetail?.followupNote) {
            const reqpayload = formatAdditionalAttributesForPayload(
            {
                ...currentLeadDetail,
                status: "LEAD_STATUS_OPEN",
                followupStatus: "LEAD_STATUS_OPEN",
                productQuantity: currentLeadDetail?.quantity,
                leadProducts: [],
            },
            [...ADDITIONAL_ATTRIBUTE_FIELDS,...CUSTOMIZABLE_FIELDS_LEAD]
            );
                             tableData.map((item,index) => {
                                reqpayload?.leadProducts?.push({
                                       sellingPrice : item?.price,
                                       productId: item?.id,
                                       productQuantity: parseFloat(item?.quantity),
                                       primaryDiscount : item?.primaryDiscount,
                                       sGst : item?.sgstRate,
                                       cGst : item?.cgstRate,
                                       surchargeRate : item?.surChangeRate 
                                })})
                dispatch(requestShowLoader());
               const response = await createRequestData(reqpayload,"leads/create");

            dispatch(requestHideLoader());

            if (response?.status === "error") {
                enqueueSnackbar(
                    handleValidateCodevalue(
                        internationalise,
                        response?.propererror?.data?.message || "COMMON_PLEASE_TRY_AGAIN"
                    ),
                    { variant: "error" }
                );
                return;
            }

            if (response?.data?.id) {
                // const selectedProduct = ...
                // await createRequestData(selectedProduct, "leadproducts/multiple");

                enqueueSnackbar(
                    handleValidateCodevalue(
                        internationalise,
                        "COMMON_CREATED_SUCCESSFULLY"
                    ),
                    { variant: "success" }
                );

                setRequiredFollowup({
                    followupNote: false,
                    followupStatus: false,
                });

                navigateTo(`${privateRoutesPath.EDIT_LEAD}/${response.data.id}`,{},searchEntity?.lead);
            }
            } else {
                setRequiredFollowup({
                    followupNote: true,
                    followupDate: true,
                    followupStatus: true
                })
                followupRef?.current?.focus();
                enqueueSnackbar(handleValidateCodevalue(internationalise,"COMMON_MSG_MANDATORY_FIELDS"),{variant:"error"})
                return;
            }
        }
        
    }

    const handleChangeQuantity = (e) => {
        setproductQuantity(e.target.value)
    }

    const filter = createFilterOptions();

    
    const handleFilterOption = (options, params) => {
         filterdOptionlist = filter(options, params);
        return [ { name: 'Select All',price: "", value: "select-all" }, ...filterdOptionlist];
    }

    const handlechangeInputprice = (event) => {
        setInputprice({
            ...inputprice,
            [event.target.name]: event.target.value
        })
    }
    const handleSelectCompany =(e,val,entity)=>{
        if(entity === "Source"){
        setCurrentLeadDetail({
            ...currentLeadDetail,
            selectedSource : val,
            source : val?.name
        })
    }
        if(entity === "Owner"){
            setCurrentLeadDetail({
            ...currentLeadDetail,
            selectedOwner : val,
            ownerId : val?.id
        })
        }
    }

    useEffect(()=>{
        dispatch(requestGetAllCustomers());
    },[])
    
    const customerData = useSelector(state=> state?.customer?.customer);

    const [openCustomerPopup,setOpenCustomerPopup] = useState({
        open: false,
        customerDropdownData: [],
        selectedCustomer: null,
    })

    const handleOpenCustomerPopup = () => {
        
        setOpenCustomerPopup({
            open : true,
            customerDropdownData : customerData
        })
    }
    const handleCloseCustomerPopup = () => {
        setOpenCustomerPopup({
            open : false,
            customerDropdownData : []
        })
    }
    const handleSelectCustomer = (e,val) => {
        handleCloseCustomerPopup()
        setCurrentLeadDetail({
            ...val,
            note : "",
            income : val?.incomeGroup,
            selectedOwner : currentLeadDetail?.selectedOwner,
            ownerId : currentLeadDetail?.selectedOwner?.id
        })
    }

    const configLabels = STATIC_ENTITY_CONFIG?.LEAD

    return (
        <BiztantuLoader open={isLoadingProgress} isChildren={true}>
        <React.Fragment>
            <Box className={isMobile ? 'globalBoxMobile':'globalBox'}>
          <StyledSubHeader>
    {handleValidateCodevalue(internationalise,'LEAD_EDIT_LEAD_DETAILS')}
</StyledSubHeader>

    <StyledGridContainer>
    <AutoCompleteComponent
        isOwner={true}
        optionSet = {(specificRolePermission?.isAllLeadManage ? ownerlist 
            : specificRolePermission?.isLeadTeamManage ? myTeam 
            : [{
        firstName: `${currentUser?.firstname}`,
        lastName : `${currentUser?.lastname}`,
        id: currentUser?.userId,
      }]) || []}
        value={currentLeadDetail?.selectedOwner || null}
        disabled= {!(specificRolePermission?.isAllLeadManage || specificRolePermission?.isLeadTeamManage)}
        name = "clientId"
        placeholder={handleValidateCodevalue(internationalise,configLabels?.selectedOwner?.label)}
        error={currentLeadDetail?.selectedOwner ? false : !!isRequired?.selectedOwner}
        required={true}
        label={handleValidateCodevalue(internationalise,configLabels?.selectedOwner?.label)}       
        onChange={(e, val) => handleSelectCompany(e, val, "Owner")}
    />
    <TextFiledWithLabel
        name="status"
        id="leadstatus"
        disabled
        value={currentLeadDetail?.followupStatus ? currentLeadDetail?.followupStatus : 'Open'}
        label={handleValidateCodevalue(internationalise,configLabels?.status?.label)}
        handleOnChange={handleChangeLeadData}
    />


    <CustomizableFields
        CUSTOMIZABLE_FIELDS = {["title"]}
        useWrapper={false}
        showHeader={false}
        entity = "LEAD"
        config={leadTextfieldsData}
        values={currentLeadDetail}
        setValues = {setCurrentLeadDetail}
        handleOnChange={handleChangeLeadData}
        errors={isRequired}
    />
    
    {leadTextfieldsData?.firstName?.visibility && (
    <TextFiledWithLabel
        name="firstName"
        error={currentLeadDetail?.firstName ? false : !!isRequired?.firstName}
        required={leadTextfieldsData?.firstName?.mandatory}
        value={currentLeadDetail?.firstName || ""}
        id="firstName" 
        label={handleValidateCodevalue(internationalise,configLabels?.firstName?.label)}
        handleOnChange={handleChangeLeadData}
    />
    )}
    {leadTextfieldsData?.lastName?.visibility && (
    <TextFiledWithLabel
        name="lastName"
        error={currentLeadDetail?.lastName ? false : !!isRequired?.lastName}
        required={leadTextfieldsData?.lastName?.mandatory}
        value={currentLeadDetail?.lastName || ""}
        id="lastName" 
        label={handleValidateCodevalue(internationalise,configLabels?.lastName?.label)}
        handleOnChange={handleChangeLeadData}
    />
    )}
    
    {leadTextfieldsData?.externalNumber?.visibility && (
    <TextFiledWithLabel 
        name="externalNumber"
        error={currentLeadDetail?.externalNumber ? false : !!isRequired?.externalNumber}
        required={leadTextfieldsData?.externalNumber?.mandatory}
        value={currentLeadDetail?.externalNumber || ""}
        id="externalNumber" 
        label={handleValidateCodevalue(internationalise,configLabels?.externalNumber?.label)}
        handleOnChange={handleChangeLeadData}
    />
    )}
    
    {leadTextfieldsData?.selectedSource?.visibility && (
    <AutoCompleteComponent
        isLookup = {true}
        optionSet = {leadSourceData}
        error={currentLeadDetail?.selectedSource ? false : !!isRequired?.selectedSource}
        required={leadTextfieldsData?.selectedSource?.mandatory}
        value={currentLeadDetail?.selectedSource || null}
        name = "source"
        placeholder={handleValidateCodevalue(internationalise,configLabels?.selectedSource?.label)}
        label={handleValidateCodevalue(internationalise,configLabels?.selectedSource?.label)}       
        onChange={(e, val) => handleSelectCompany(e, val, "Source")}
    />
    )}
    
    {leadTextfieldsData?.occupation?.visibility && (
    <TextFiledWithLabel 
        name="occupation"
        error={currentLeadDetail?.occupation ? false : !!isRequired?.occupation}
        required={leadTextfieldsData?.occupation?.mandatory}
        value={currentLeadDetail?.occupation || ""}
        
        id="occupation" 
        label={handleValidateCodevalue(internationalise,configLabels?.occupation?.label)}
        handleOnChange={handleChangeLeadData}
    />
    )}
   
    {leadTextfieldsData?.desirability?.visibility && (
    <SelectBoxWithLabel
        ownerdropdown = {false}
        isStatic= {false}
        name= "desirability"
        error={currentLeadDetail?.desirability ? false : !!isRequired?.desirability}
        required={leadTextfieldsData?.desirability?.mandatory}
        value={currentLeadDetail?.desirability || ""}
        label={handleValidateCodevalue(internationalise,configLabels?.desirability?.label)}
        optionMenuItem={leadDesrirabilityData}
        handleOnChange={handleChangeLeadData}
    />
    )}
    
                <CustomizableFields
                CUSTOMIZABLE_FIELDS={
                CUSTOMIZABLE_FIELDS_LEAD.filter(
                    field => field !== "title"
                        )
                    }
                    useWrapper={false}
                showHeader={false}
                entity = "LEAD"
                config={leadTextfieldsData}
                values={currentLeadDetail}
                setValues = {setCurrentLeadDetail}
                handleOnChange={handleChangeLeadData}
                errors={isRequired}
                />
</StyledGridContainer>

                <CustomizableFields
                CUSTOMIZABLE_FIELDS = {ADDITIONAL_ATTRIBUTE_FIELDS}
                entity = "LEAD"
                config={leadTextfieldsData}
                values={currentLeadDetail}
                setValues = {setCurrentLeadDetail}
                handleOnChange={handleChangeLeadData}
                errors={isRequired}
                />
                 <CommonComm
                 required= {true}
                 isDetailPage = {true}
                 requiredValue={isRequired}
                 handleOnChange={handleChangeLeadData}
                 state = {currentLeadDetail}
                 
                 />
                    <AddressFields
                    setEntityDetails={setCurrentLeadDetail}
                    onChange={handleChangeLeadData}
                    entityDetails={currentLeadDetail}
                    />        
                    <CommonPoc
                    isDetailPage={true}
                    requiredValue={false}
                    handleOnChange={handleChangeLeadData}
                    state={currentLeadDetail}
                    />
                    <EntityNote
                    entityDetails = {currentLeadDetail} 
                    onChange = {handleChangeLeadData}
                    headingLabel = {handleValidateCodevalue(internationalise,"COMMON_SPECIAL_NOTE")}
                    />

                       <LeadAccordion
  label={handleValidateCodevalue(internationalise,'LEAD_EDIT_FOLLOW_UP')}
  defaultOpen = {true}  
>
                   {
                    true && (
                        <StyledLeadContainer>
                            <TextFiledWithLabel 
                                id="standard-basic" 
                                label={handleValidateCodevalue(internationalise,"LEAD_EDIT_FU_NOTE")}
                                inputRef = {followupRef}
                                required={true}
                                name="followupNote"
                                value={currentLeadDetail?.followupNote}
                                handleOnChange={handleChangeLeadData}
                                className="create-lead-followup-note"
                                error={currentLeadDetail?.followupNote ? false :requiredFollowUp?.followupNote}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                 
                            />
                            <TextFiledWithLabel
                                className={isMobile ? 'mt-15 create-lead-followup-date' : 'create-lead-followup-date'}
                                id="lead-follow-up"
                                type="date"
                                name="followupDate"
                                value={currentLeadDetail?.followupDate}
                                label={handleValidateCodevalue(internationalise,"LEAD_EDIT_NEXT_FU_DATE")}
                                handleOnChange={handleChangeLeadData}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            ></TextFiledWithLabel>
                           
                        </StyledLeadContainer>
                    )
                   }
                   </LeadAccordion>
                   
                <LeadProduct 
                    data={tableData}
                    defaultAccordionOpen={leadData?.selectedProductIds?.length > 0}
                    selectedaddedproduct={selectedaddedproduct}
                    selectedproductData={selectedproductData}
                    selectedproduct={selectedproduct}
                    handleChangeQuantity={handleChangeQuantity}
                    productQuantity={productQuantity}
                    getDataGridData={(data) => setTableData(data)}
                    handleSelectMultiproduct={handleSelectMultiproduct}
                    handleFilterOption={handleFilterOption}
                    inputprice={inputprice}
                    handlechangeInputprice={handlechangeInputprice}
                    // handleChangerange={handleChangerange}
                    pricerange={pricerange}
                    handleClearAfterAdded={handleClearAfterAdded}
                    accordionLabel = {handleValidateCodevalue(internationalise,'LEAD_INTERESTED_IN_PRODUCTS')}
                />

                {/* <LeadAccordion 
                    label="Documents"  
                >
                    {!isAddDocumentDialog &&  <Button variant="outlined" name="document" onClick={handleAddDocument}>Add Product</Button>}
                   {
                    isAddDocumentDialog && (
                        <StyledLeadContainer>
                            <TextField 
                                required 
                                id="standard-basic" 
                                label="Type" 
                                select
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                            <TextField 
                                required 
                                id="standard-basic" 
                                label="Name" 
                                select
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                            <TextField 
                                required 
                                type="file"
                                id="standard-basic" 
                                label="Upload file" 
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                        </StyledLeadContainer>
                    )
                   }
                   {isAddDocumentDialog &&  (
                   <div style={{textAlign: 'center', marginTop: 20}}>
                        <Button variant="outlined" name="document" onClick={() => setIsAddDocumentDialog(false)}>Cancel</Button>
                   </div>
                   )}
                </LeadAccordion> */}
                
            </Box>
            <CreateLeadFooter>
                <Stack alignItems="center" display={"flex"} flexWrap={isMobile ? "nowrap" : "wrap"} gap={isMobile ? "0px" : "5px"} justifyContent={"space-between"} flexDirection="row">
                    <Typography variant='h6'>
                        {handleValidateCodevalue(internationalise,'LEAD_EDIT_TITLE_CREATE')}
                    </Typography>
                    {isMobile &&
                       <>
                       <Button 
                               className="edit-primary btn-space"
                               variant="outlined"
                               onClick={goBack}
                           >
                               <ArrowBackIcon />
                           </Button>
                           <Button
                               className="edit-primary"
                               variant="outlined"
                               onClick={handleSaveLaed}
                           >
                               <CheckIcon />
                           </Button>
                           </>
                        }   
                    {!isMobile &&
                    <>
                    <Button className={ !isMobile ? 'edit-primary btn-space' : 'edit-primary'} variant="outlined" onClick={goBack}>{handleValidateCodevalue(internationalise,'COMMON_BACK')}</Button>
                    <Button className='edit-primary' variant="outlined" 
                    onClick={handleSaveLaed}>{handleValidateCodevalue(internationalise,'COMMON_SAVE')}</Button>
                    </>
                    }
                </Stack>
                
                {(!isMobile && !leadData?.currentLeadDetail) &&
                <Stack>
                    <StyledFlexEnd>
                        <Tooltip title={handleValidateCodevalue(internationalise,"CREATE_FOR_EXISTING_CUST")}>
                            <Button className='secondry-edit-btn' variant="outlined" onClick={handleOpenCustomerPopup}>{handleValidateCodevalue(internationalise,"CREATE_FOR_CUSTOMER")}</Button>
                        </Tooltip>
                    </StyledFlexEnd>
                </Stack>
                }
                </CreateLeadFooter>
                {openCustomerPopup?.open &&(
                    <LeadDialog
                        open = {openCustomerPopup?.open}
                        handleClose = {handleCloseCustomerPopup}
                        // handleSave={}
                        title= {handleValidateCodevalue(internationalise,"LEAD_SELECT_CUSTOMER")}
                        size="sm"
                        alternateBtnLabel={handleValidateCodevalue(internationalise,"COMMON_CANCEL")}>

                    <AutoCompleteComponent
                        isOwner = {true}
                        optionSet = {openCustomerPopup?.customerDropdownData}
                        value={openCustomerPopup?.selectedCustomer|| null}
                        name = "selectedCustomer"
                        placeholder={handleValidateCodevalue(internationalise,'LEAD_SELECT_CUSTOMER')}
                        label={handleValidateCodevalue(internationalise,'LEAD_SELECT_CUSTOMER')}
                        onChange={(event, Owner) => handleSelectCustomer(event, Owner,"Customer")}
                    />
                    </LeadDialog>
                )

                }
        </React.Fragment>
        </BiztantuLoader>
    )
}



export default CreateLead;
